import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ModalModule } from 'ngx-bootstrap/modal';
import { JobBoardsSupportedParametersComponent } from './job-boards-supported-parameters.component';
import { JobBoardsSearchHistoryModule } from './job-boards-search-history/job-boards-search-history.module';

@NgModule({
  declarations: [JobBoardsSupportedParametersComponent],
  imports: [
    CommonModule,
    FormsModule,
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    ModalModule.forRoot(),
    JobBoardsSearchHistoryModule
  ],
  exports: [JobBoardsSupportedParametersComponent],
  entryComponents: [JobBoardsSupportedParametersComponent]
})
export class JobBoardsSupportedParametersModule { }
